import { useGetCreatorDataQuery } from "../redux/reduxAPI";
import { useGetCreatorConfigQuery } from "../redux/efficientReduxAPI";
import { useSelector } from "react-redux";

export const useGetCreatorDataWithCreatorIdQuery = () => {
  const creatorLoggedIn = useSelector(
    (state) => state.appReducer.creatorLoggedIn
  );
  const { data: dataCreatorConfig } = useGetCreatorConfigQuery(undefined, {
    skip: !creatorLoggedIn,
  });
  const result = useGetCreatorDataQuery(
    {
      creatorId: dataCreatorConfig?.creator_id,
    },
    {
      skip: !dataCreatorConfig?.creator_id,
    }
  );
  return result;
};
